import { IncentiveType, PortalType, IncentiveStep, IncentiveLocation } from 'interfaces';
import { IIncentiveV2Getters, IIncentiveV2State } from '@/domain/dto/store.incentive-v2.interfaces';
import { IErrorMessage } from '@/domain/dto/error-message.interface';

const EMAIL_REGEX = /^([a-zA-Z0-9_.\-+%])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
const MIN_PASSWORD_LENGTH = 8;

export class IncentiveV2Getters implements IIncentiveV2Getters {
	private readonly state: IIncentiveV2State;

	public constructor(state: IIncentiveV2State) {
		this.state = state;
	}

	public step(): IncentiveStep {
		return this.state.step;
	}

	public location(): IncentiveLocation | undefined {
		return this.state.location;
	}

	public incentiveType(): IncentiveType | undefined {
		return this.state.incentiveType;
	}

	public uniqueIdentifier(): string | undefined {
		return this.state.uniqueIdentifier;
	}

	public portalType(): PortalType | null {
		return this.state.portalType;
	}

	public name(): string | null {
		return this.state.name;
	}

	public email(): string | null {
		return this.state.email;
	}

	public password(): string | null {
		return this.state.password;
	}

	public confirmPassword(): string | null {
		return this.state.confirmPassword;
	}

	public accessToken(): string | null {
		return this.state.accessToken;
	}

	public pending(): boolean {
		return this.state.pending;
	}

	public errorMessage(): IErrorMessage {
		return this.state.errorMessage;
	}

	public isValidName(): boolean {
		return !!this.state.name;
	}

	public isValidEmail(): boolean {
		return !!this.state.email && EMAIL_REGEX.test(this.state.email);
	}

	public isValidPassword(): boolean {
		return !!this.state.password && this.state.password.length >= MIN_PASSWORD_LENGTH;
	}

	public showNameError(): boolean {
		return this.state.name !== null && !this.isValidName();
	}

	public showEmailError(): boolean {
		return this.state.email !== null && !this.isValidEmail();
	}

	public showPasswordError(): boolean {
		return this.state.password !== null && !this.isValidPassword();
	}
}
